import React from "react";
import { FEATURES } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Features() {
  return (
    <section id="features" className="relative py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">Why InstantDrive</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            Built for trust and speed
          </h2>
          <p className="mt-4 text-white/60 text-lg">
            Everything you need for a safe, fair and reliable ride — for riders and drivers alike.
          </p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.title} delay={i * 80}>
                <div className="group h-full rounded-3xl border border-white/10 bg-[#0e1311] p-7 transition-all duration-300 hover:bg-[#0f1613] hover:border-[#2fd645]/40">
                  <div className="h-13 w-13 p-3 rounded-2xl bg-[#2fd645]/12 border border-[#2fd645]/25 inline-flex transition-transform group-hover:scale-110">
                    <Icon className="h-7 w-7 text-[#2fd645]" />
                  </div>
                  <h3 className="mt-5 text-lg font-bold text-white">{f.title}</h3>
                  <p className="mt-2 text-white/60 leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
